import { get, post, postMulti, httpDelete, download } from '../axiosReq'

export const apiDrcUpload = parmas => postMulti('/drc/upload/', parmas)
// export const apiDrcTaskRun = file_id => get('/drc/task/' + file_id)
export const apiDrcTaskRun = parmas => get('/drc/task', parmas)
export const apiDrcTaskResult = task_id => get('/drc/result/' + task_id)

export const apiDrcTest = parmas => get('/drc/test', parmas)
